import {
	Row,
} from 'native-base';

export default function Footer(props) {
	return <Row
				bg="trueGray.200"
				alignItems="center"
				justifyContent="center"
				alignSelf="flex-end"
				w="100%"
				pt={3}
				pb={2}
				px={3}
				safeAreaBottom
				{...props}
			>
				{props.children}
			</Row>;
}
